import {
  Form,
  Input,
  Popconfirm,
  Table,
  Typography,
  Select,
  message,
  Button,
  Radio,
  Modal,
  Space,
  Layout,
} from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";
import "./index.css";
import httpUtil from "../../../../utils/httpUtil";

const { Option } = Select;
const { Header } = Layout;

export const UsersMaster = () => {
  // 外层表格的 Form 实例（用于编辑行数据）
  const [tableForm] = Form.useForm();
  // 独立的 Modal Form 实例（用于添加学生）
  const [modalForm] = Form.useForm();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingKey, setEditingKey] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [searchType, setSearchType] = useState("username"); 
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    getAllUsers();
  }, []);

  //获取全部用户
  const getAllUsers = () => {
    setLoading(true);
    httpUtil
      .getAllUsers({})
      .then((res) => {
        if (res.success) {
          setData(res.data);
        } else {
          message.error(res.error);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 表格
  const columns = [
    { title: "用户ID", dataIndex: "user_id", width: "12%", editable: false },
    { title: "登录账号", dataIndex: "username", width: "12%", editable: true },
    {
      title: "登录密码",
      dataIndex: "password",
      width: "12%",
      editable: false,
      render: () => "******",
    },
    { title: "角色", dataIndex: "role", width: "10%", editable: true },
    { title: "用户姓名", dataIndex: "full_name", width: "12%", editable: true },
    { title: "联系方式", dataIndex: "contact", width: "12%", editable: true },
    {
      title: "操作",
      dataIndex: "operation",
      width: "30%",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <span>
            <Typography.Link
              onClick={() => save(record.user_id)}
              style={{ marginRight: 8 }}
            >
              保存
            </Typography.Link>
            <Popconfirm
              title="确定取消吗?"
              onConfirm={cancel}
              okText={"确定"}
              cancelText={"取消"}
            >
              <Typography.Link>取消</Typography.Link>
            </Popconfirm>
          </span>
        ) : (
          <span>
            <Typography.Link
              disabled={editingKey !== ""}
              onClick={() => edit(record)}
              style={{ marginRight: 8 }}
            >
              编辑
            </Typography.Link>
            <Popconfirm
              title="确定重置密码为123456吗?"
              onConfirm={() => resetPassword(record.user_id)}
              okText={"确定"}
              cancelText={"取消"}
            >
              <Typography.Link style={{ marginRight: 8 }}>
                重置密码
              </Typography.Link>
            </Popconfirm>
            <Popconfirm
              title="确定删除此用户吗?"
              onConfirm={() => handleDelete(record.user_id)}
              okText={"确定"}
              cancelText={"取消"}
            >
              <Typography.Link type="danger">删除</Typography.Link>
            </Popconfirm>
          </span>
        );
      },
    },
  ];
  const mergedColumns = columns.map((col) => {
    if (!col.editable) return col;
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.dataIndex === "contact" ? "number" : "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    children,
    ...restProps
  }) => {
    const getInputNode = () => {
      if (dataIndex === "role") {
        return (
          <Select>
            <Option value="管理员">管理员</Option>
            <Option value="辅导员">辅导员</Option>
            <Option value="教师">教师</Option>
            <Option value="学生">学生</Option>
          </Select>
        );
      } else if (dataIndex === "contact") {
        return <Input style={{ width: "100%" }} />;
      }
      return <Input />;
    };

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{ margin: 0 }}
            rules={[
              ...(dataIndex !== "contact"
                ? [{ required: true, message: `请输入${title}` }]
                : []),
            ]}
          >
            {getInputNode()}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
  const isEditing = (record) => record.user_id === editingKey;
  const edit = (record) => {
    tableForm.setFieldsValue({ ...record });
    setEditingKey(record.user_id); 
  };
  const cancel = () => setEditingKey("");
  const save = (user_id) => {
    tableForm
      .validateFields()
      .then((row) => {
        const newData = [...data];
        const index = newData.findIndex((item) => user_id === item.user_id);
        if (index > -1) {
          const updatedUser = { ...newData[index], ...row };
          httpUtil
            .updateUsers(updatedUser)
            .then((res) => {
              if (res.success) {
                newData.splice(index, 1, updatedUser);
                setData(newData);
                setEditingKey("");
                message.success("更新成功");
              } else {
                message.error(res.error || "更新失败");
              }
            })
            .catch((err) => {
              console.error("更新出错：", err);
              message.error("更新请求失败");
            });
        }
      })
      .catch((err) => {
        console.log("验证失败:", err);
      });
  };
  const handleDelete = (user_id) => {
    const data = { user_id };
    try {
      httpUtil.deleteUsers(data).then((res) => {
        if (res.success) {
          setData((prevData) =>
            prevData.filter((item) => item.user_id !== user_id)
          );
          message.success(`用户 ${user_id} 删除成功`);
        } else {
          message.error(res.error || "删除用户失败");
        }
      });
    } catch (err) {
      console.error("删除用户错误:", err);
      message.error("删除用户时发生错误");
    }
  };
  const resetPassword = (user_id) => {
    const newData = [...data];
    const index = newData.findIndex((item) => user_id === item.user_id);
    const params = { user_id, newPassword: "123456" };
    if (index > -1) {
      httpUtil.resetUsers(params).then((res) => {
        if (res.success) {
          newData[index].password = "123456";
          setData(newData);
          message.success("密码已重置!");
        } else {
          message.error("重置失败！");
        }
      });
    } else {
      message.error("重置失败！");
    }
  };

  // Modal 表单逻辑
  const showModal = () => setOpen(true);
  const handleCancel = () => {
    modalForm.resetFields();
    setOpen(false);
  };
  const handleOk = () => {
    modalForm.submit();
  };
  const handleAddUser = (values) => {
    setConfirmLoading(true);
    const { userName, password, full_name, role } = values;
    const data = { userName, password, full_name, role };
    tableForm.resetFields(); // 清空所有表单字段
    httpUtil
      .register(data)
      .then((res) => {
        if (res.success) {
          message.success("注册成功！");
          modalForm.resetFields();
        } else {
          message.error(res.error);
        }
      })
      .finally(() => {
        setConfirmLoading(false);
      });
  };

  // 搜索函数
  const getSearchPlaceholder = (type) => {
    switch (type) {
      case "username":
        return "登录账号";
      case "full_name":
        return "用户姓名";
      case "role":
        return "角色（管理员/辅导员/教师/学生）";
      default:
        return "搜索内容";
    }
  };

  const handleSearch = () => {
    if (!searchText.trim()) {
      getAllUsers();
      return;
    }
    setLoading(true);
    const data = { type: searchType, keyword: searchText };
    // 如果是从服务器搜索，可以这样实现：
    httpUtil
      .searchUsers(data)
      .then((res) => {
        if (res.success) {
          message.success("搜索成功！");
          setSearchText("");
          setData(res.data);
          setPagination({ current: 1, pageSize: 10 });
        } else {
          message.error(res.error);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Header style={{ padding: 0, background: "#fff" }}>
        <Space align="center">
          <Radio.Group
            value={searchType}
            onChange={(e) => setSearchType(e.target.value)}
            style={{ marginRight: 16 }}
          >
            <Radio value="username">登录账号</Radio>
            <Radio value="full_name">用户姓名</Radio>
            <Radio value="role">角色</Radio>
          </Radio.Group>

          <Input.Search
            placeholder={`请输入${getSearchPlaceholder(searchType)}`}
            enterButton="搜索"
            style={{ width: 350, display: "block" }}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onSearch={handleSearch}
          />

          <Button
            type="primary"
            style={{ margin: "0 30px" }}
            onClick={() => {
              getAllUsers();
              setSearchText("");
              setSearchType("username");
            }}
          >
            重置
          </Button>
          <Button
            type="primary"
            onClick={showModal}
            style={{ margin: "0 30px" }}
          >
            添加用户
          </Button>
        </Space>
      </Header>
      <Form form={tableForm} component={false}>
        <Table
          loading={loading}
          components={{ body: { cell: EditableCell } }}
          bordered
          rowKey="user_id"
          dataSource={data}
          columns={mergedColumns}
          rowClassName="editable-row"
          pagination={{
            ...pagination,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            onChange: (page, pageSize) => {
              setPagination({ current: page, pageSize });
              cancel();
            },
          }}
          scroll={{ y: 400, x: "max-content" }}
        />

        {/* 添加学生的 Modal */}
        <Modal
          title="添加用户信息"
          open={open}
          onOk={handleOk}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
          destroyOnClose
          okText={"确定"}
          cancelText={"取消"}
        >
          <div className="addusercontent">
            <Form
              form={modalForm} // 将form实例绑定到Form组件
              name="normal_login"
              className="login-form"
              initialValues={{
                role: "学生",
              }}
              onFinish={handleAddUser}
            >
              <Form.Item
                name="full_name"
                rules={[
                  {
                    required: true,
                    message: "请输入您的姓名",
                  },
                ]}
              >
                <Input
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="请输入您的姓名！"
                />
              </Form.Item>

              <Form.Item
                name="userName"
                rules={[
                  {
                    required: true,
                    message: "请输入您的账号!",
                  },
                ]}
              >
                <Input
                  prefix={<UserOutlined className="site-form-item-icon" />}
                  placeholder="请使用学号/教师号注册"
                />
              </Form.Item>

              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "请输入您的密码!",
                  },
                ]}
              >
                <Input
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="密码"
                />
              </Form.Item>

              <Form.Item
                name="rePassword"
                dependencies={["password"]}
                hasFeedback
                rules={[
                  {
                    required: true,
                    message: "请确认您的密码!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("您输入的两次密码不匹配!")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="确认密码"
                />
              </Form.Item>

              <Form.Item name={"role"} noStyle>
                <Radio.Group>
                  <Space>
                    <Radio value={"学生"}>学生</Radio>
                    <Radio value={"教师"}>教师</Radio>
                    <Radio value={"辅导员"}>辅导员</Radio>
                    <Radio value={"管理员"}>管理员</Radio>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Form>
          </div>
        </Modal>
      </Form>
    </div>
  );
};
